export enum RichTextType {
  HTML = 0,
  Markdown = 1,
}

export type RichText = {
  type: RichTextType;
  value: string;
};
